module.exports = __webpack_public_path__ + "img/fas-undo-alt.6541d95f.svg";